import MainTestScenario from './MainTestScenario';
import { constants, Globals } from '../../../../misc/helpers';
import { ScenarioEndType, ScenarioSceneType, StepToSkip } from '../../../../misc/BleedingControlScenario';

export default class MainTestScenarioSteps7And8 {
	constructor(private mainScenario: MainTestScenario, private onDone: (indx: number, aarReady7: boolean) => void, public showFailedAar: () => void) {
	}

	start() {
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		if(this.mainScenario.skipBCK === true) {
			this.step2TourniqueteSelected();
		}
		else {
			this.step1ShowBleedingControlKit();
		}
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BleedingControlKit, {
			onSelectionChanged: (index: number) => {
				if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
					return;
				}
				if(index === 1) {
					context.step2TourniqueteSelected();
				}
				else if(index === 2) {
					context.onDone(-2, false);
				}
				else if(index === 0) {
					context.onDone(-3, false);
				}
				else {
					// context.step2TourniqueteNotSelected();
					context.onDone(index, false);
				}
			}
		});
	}

	private step2TourniqueteSelected() {
		var context = this;

		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
		this.step3PlaceTourniqueteAboveWound();
		context.mainScenario.playSound('Step-8', '3', () => {
			context.mainScenario.playSound('Step-8', '4', () => {
	});
});
	}
	// private step2TourniqueteNotSelected() {
	// 	var context = this;
	// 	context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
	// 	this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	// }

	private step3PlaceTourniqueteAboveWound() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to apply the tourniquet above the wound?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps7And8.step3PlaceTourniqueteAboveWound', () => context.step3PlaceTourniqueteAboveWoundYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step3PlaceTourniqueteAboveWoundNo()
			}
		});
	}

	private step3PlaceTourniqueteAboveWoundYes() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		if(this.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioD && this.mainScenario.endAt !== ScenarioEndType.firstTourniquete) {
			context.mainScenario.gameManager.UiManager.hideaAllUis();
		}
		else if(context.mainScenario.steps3Done === true) {
			context.mainScenario.playSequence('ApplyPressureEnd', null, ()=> {
			});
		}
		context.step4TourniqueteInteraction();
		context.mainScenario.playSound('Step-8', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');

			context.mainScenario.playSound('Step-8', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');

		});
	});
	}
	private step3PlaceTourniqueteAboveWoundNo() {
		this.step1ShowBleedingControlKit();
		// var context = this;
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3PlaceTourniqueteAboveWound());
	}

	private step4TourniqueteInteraction() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		Globals.stopTimer = false;
		this.mainScenario.playSequence('TourniqueteSetup', null, () => {
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				correctIndex1: context.mainScenario.correctT1, 
				wrongIndex: context.mainScenario.wrongT1,
				closeIndex: context.mainScenario.closeT1,
				locations: context.mainScenario.locations,
				isTestScenario: true,
				isSceneA: context.mainScenario.SceneAT,
				isSceneB: context.mainScenario.SceneBT,
				isSceneC: context.mainScenario.SceneCT,
				isSceneD: context.mainScenario.SceneDT,
				onDone: (selectedNumber: number, isCorrect: boolean) => {
					context.mainScenario.selectedTourniquetIndex = selectedNumber;
					if(isCorrect) {
						context.step4TourniqueteInteractionCorrect();
					} else {
						context.step4TourniqueteInteractionIncorrect();
					}
				}
			});
		});
		this.mainScenario.playSequence('DisableBystander');
	}

	private step4TourniqueteInteractionCorrect() {
		var context = this;
		if(this.mainScenario.stepsOrder7 === true) {
			this.mainScenario.aarApplyFirstTourniquete = true;
		}
		else {
			this.mainScenario.aarApplyFirstTourniquete = false;
		}
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		//context.mainScenario.playSequence('Steps7And8Cinematic', null, () => {
			context.onDone(-1, true);
		//});
	}
	private step4TourniqueteInteractionIncorrect() {
		var context = this;
		if(this.mainScenario.stepsOrder7 === true && this.mainScenario.endAt === ScenarioEndType.pressureDressing) {
			this.mainScenario.aarApplyFirstTourniquete = true;
		}
		else {
			this.mainScenario.aarApplyFirstTourniquete = false;
		}
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		//context.mainScenario.playSequence('Steps7And8Cinematic', null, () => {
			context.onDone(-1, true);
		//});
		// var context = this;
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step4TourniqueteInteraction());
	}
}